module.exports = {"version":"1.2.1.9"}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = c+VB
// module chunks = 120